/* CONCEPTS */
export const MESSAGE_LOAD = "MESSAGE_LOAD";
export const MESSAGE_LOAD_SUCCESS = "MESSAGE_LOAD_SUCCESS";
export const MESSAGE_ERROR = "MESSAGE_ERROR";
export const MESSAGE_CLEAN = "MESSAGE_CLEAN";
